import React from "react";
import ShopSettings from "../../components/Shop/ShopSettings";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";

const ShopSettingsPage = () => {
  return (
    <div className="min-h-screen bg-secondary-50">
      <DashboardSideBar active={10} />
      <div className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          <ShopSettings />
        </div>
      </div>
    </div>
  );
};

export default ShopSettingsPage;



